import { Grid, Button } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  capitalizeFirstLetterOfEveryWord,
  formatLength,
  showNotification,
} from "../../../../constants";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";
import QTDetailsImageWithLabelSection from "../../../../common/QTDetailsImageWithLabelSection";
import QTDetailsAudioWithLabelSection from "../../../../common/QTDetailsAudioWithLabelSection";
import { useContributorsContext } from "../../../../providers/OrganizationAdmin/ContributorsProvider";
import QTDetailsAutoCompleteWithLabelSection from "../../../../common/QTDetailsAutoCompleteWithLabelSection";
import QTDetailsLatLongSection from "../../../../common/QTDetailsLatLongSection";
import QTDetailsLocationWithLabelSection from "../../../../common/QTDetailsLocationWithLabelSection";
import { getCreatedByDisplay } from "../../../../utils/createdByUtils";

const DetailsPageBottomCardSection = ({
  quicktaleDetails,
  setQuicktaleDetails,
  handleImagePreviewModalOpen,
  handleAudioModalOpen,
  editEnabled,
  uploadImage,
  setUploadImage,
  uploadAudioFile,
  setUploadAudioFile,
  narratorError,
  // The logged-in admin's organization. Enables a one-click "Set to Org"
  // button on the Created By field so the QT can be attributed to the org.
  currentOrganization = null,
  // Optional: persist the createdBy change immediately (used in view mode
  // where there is no Save button). Receives the new createdBy id.
  onCreatedBySet,
}) => {
  const { GAUsers, handleGetAllGAUsers } = useContributorsContext();
  const [usersData, setUsersData] = useState([]);

  useEffect(() => {
    if (GAUsers && GAUsers?.length > 0) {
    } else {
      handleGetAllGAUsers();
    }
  }, []);

  useEffect(() => {
    setUsersData(GAUsers);
  }, [GAUsers]);

  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        {/*QT Title section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"QT Title"}
          value={quicktaleDetails.title}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              title: capitalizeFirstLetterOfEveryWord(e.target.value),
              // title: e.target.value,
            })
          }
        />
        {/*QT ID section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"QT ID"}
          value={quicktaleDetails.id}
          disabled={true}
          // editEnabled={editEnabled}
          // onChange={(e) =>
          //   setQuicktaleDetails({
          //     ...quicktaleDetails,
          //     id: e.target.value,
          //   })
          // }
        />
        {/*photo section*/}
        <QTDetailsImageWithLabelSection
          label={"QT Photo"}
          // image={images.tableDummyImage}
          // handleImagePreviewModalOpen={handleImagePreviewModalOpen}
          image={quicktaleDetails.photoUrl || (quicktaleDetails.imageUrls && quicktaleDetails.imageUrls[0])}
          // image={images.tableDummyImage}
          fileName={
            quicktaleDetails?.imageFileNames?.[0] || 
            quicktaleDetails?.originalPhotoName
          }
          handleImagePreviewModalOpen={() => {
            handleImagePreviewModalOpen();
          }}
          editEnabled={editEnabled}
          details={quicktaleDetails}
          setDetails={setQuicktaleDetails}
          uploadImage={uploadImage}
          setUploadImage={setUploadImage}
        />
        {/*audio section*/}
        <QTDetailsAudioWithLabelSection
          label={"QT Audio File"}
          handleAudioModalOpen={handleAudioModalOpen}
          editEnabled={editEnabled}
          details={quicktaleDetails}
          setDetails={setQuicktaleDetails}
          uploadAudioFile={uploadAudioFile}
          setUploadAudioFile={setUploadAudioFile}
        />

        {/*Description section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Description"}
          value={quicktaleDetails.description}
          disabled={true}
          multiline={true}
          rows={5}
          editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              description: e.target.value,
            })
          }
        />
      </Grid>
      {/*right side column*/}
      <Grid item container direction={"column"} xs>
        {/*Created By section*/}
        <QTDetailsAutoCompleteWithLabelSection
          label={"Created By"}
          value={(() => {
            // No resolved data yet, but the raw id matches the admin's own org:
            // show the org name instead of the bare id.
            if (
              quicktaleDetails?.createdByData == null &&
              currentOrganization?.id &&
              quicktaleDetails?.createdBy === currentOrganization.id
            ) {
              return currentOrganization.name || quicktaleDetails?.createdBy || "";
            }
            // Shared resolver: handles user vs organization display.
            return getCreatedByDisplay(
              quicktaleDetails?.createdByData,
              quicktaleDetails?.createdBy || ""
            );
          })()}
          onChange={(docData) => {
            if (docData.id) {
              setQuicktaleDetails({
                ...quicktaleDetails,
                createdByData: docData,
                createdBy: docData.id,
              });
            } else {
              setQuicktaleDetails({
                ...quicktaleDetails,
                createdByData: null,
                // createdBy: docData.fullName,
                createdBy: quicktaleDetails.createdBy,
              });
            }
          }}
          disabled={true}
          optionsData={usersData}
          editEnabled={editEnabled}
        />
        {/* "Set to Org" — one-click attribution of Created By to the admin's own
            organization. Available in both view and edit mode. Stores
            organizations.id in createdBy (no type flag). */}
        {currentOrganization?.id && (
          <Grid container alignItems={"flex-start"} style={{ marginTop: -20, marginBottom: 16 }}>
            {/* Sits directly under the "Created By" label */}
            <div style={{ width: "25%", paddingLeft: "2%" }}>
              <Button
                variant="text"
                size="small"
                onClick={() => {
                  setQuicktaleDetails({
                    ...quicktaleDetails,
                    createdBy: currentOrganization.id,
                    createdByData: {
                      ...currentOrganization,
                      id: currentOrganization.id,
                      _sourceType: "organization",
                    },
                  });
                  // In view mode there is no Save button, so persist right away.
                  // In edit mode the change is saved with the rest of the form.
                  if (!editEnabled && typeof onCreatedBySet === "function") {
                    onCreatedBySet(currentOrganization.id);
                  } else {
                    showNotification("Created By updated successfully!");
                  }
                }}
                sx={{
                  textTransform: "none",
                  color: "#00A7CD",
                  fontFamily: "Avenir Book, sans-serif",
                  fontSize: 11,
                  padding: "0 4px",
                  minWidth: 0,
                  marginTop: '-40px',
                  marginLeft: '-20px',
                }}
              >
                Set to {currentOrganization.name || "Org"}
              </Button>
            </div>
            <span style={{ width: "70%" }} />
          </Grid>
        )}
        {/* <QTDetailsTextFieldWithLabelSection
          label={"Created By"}
          value={
            quicktaleDetails.createdByData &&
            quicktaleDetails.createdByData?.userName
          }
          disabled={true}
          // editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              createdBy: e.target.value,
            })
          }
        /> */}
        {/*Told By section*/}
        <QTDetailsAutoCompleteWithLabelSection
          label={"Told By*"}
          value={
            quicktaleDetails?.narratorData != null
              ? `${quicktaleDetails.narratorData.firstName} ${quicktaleDetails.narratorData.lastName}`
              : quicktaleDetails.narrator || ""
          }
          onChange={(docData) => {
            if (docData.id) {
              setQuicktaleDetails({
                ...quicktaleDetails,
                narratorData: docData,
                narrator: docData.id,
                // narrator: `${docData.firstName} ${docData.lastName}`,
              });
            } else {
              setQuicktaleDetails({
                ...quicktaleDetails,
                narratorData: null,
                narrator: docData.fullName,
              });
            }
          }}
          disabled={true}
          optionsData={usersData}
          editEnabled={editEnabled}
          error={narratorError}
        />
        {/* <QTDetailsTextFieldWithLabelSection
          label={"Told By"}
          value={
            quicktaleDetails.narratorData
              ? quicktaleDetails.narratorData?.userName
              : quicktaleDetails.narrator
          }
          disabled={true}
          // editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              toldBy: e.target.value,
            })
          }
        /> */}
        {/*who Can Listen section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Who Can Listen"}
          value={quicktaleDetails.status}
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["public", "private", "unlisted"]}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              status: e.target.value,
            })
          }
        />

        {/*length section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Length"}
          value={
            quicktaleDetails?.audioLength &&
            formatLength(quicktaleDetails.audioLength)
          }
          disabled={true}
          // editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              audioLength: e.target.value,
            })
          }
        />
        {/*tags section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Tags"}
          value={quicktaleDetails.tags}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              tags: e.target.value,
            })
          }
        />
        {/*qt Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Status Change Date"}
          value={(() => {
            const updatedAt = quicktaleDetails?.approvalStatus?.updatedAt;
            if (!updatedAt) return "";
            // Handle Firestore Timestamp (preferred)
            if (typeof updatedAt?.toDate === "function") {
              return moment(updatedAt.toDate()).format("MM-DD-YYYY");
            }
            // Handle Firestore Timestamp-like object
            if (typeof updatedAt?.seconds === "number") {
              return moment.unix(updatedAt.seconds).format("MM-DD-YYYY");
            }
            // Handle JS Date / ISO string
            const m = moment(updatedAt);
            return m.isValid() ? m.format("MM-DD-YYYY") : "";
          })()}
          // value={quicktaleDetails.qtStatus}
          disabled={true}
          // editEnabled={editEnabled}
          onChange={(e) =>
            setQuicktaleDetails({
              ...quicktaleDetails,
              statusChangeDate: e.target.value,
            })
          }
        />

        {/*location section*/}
        <QTDetailsLocationWithLabelSection
          label={"Location"}
          locationDisplayValue={quicktaleDetails?.locationDisplay}
          value={quicktaleDetails?.location || ""}
          quicktaleDetails={quicktaleDetails}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(docData) => {
            console.log("doc data::", docData);
            setQuicktaleDetails({
              ...quicktaleDetails,
              coordinates: docData.coordinates,
              location: docData.location,
              locationDisplay: docData.locationDisplay,
              locationCountry: docData.locationCountry,
              g: docData.g,
            });
            // setQuicktaleDetails({ ...quicktaleDetails, ...docData });
          }}
          // onChange={(docData) => {
          //   console.log("doc data::", docData);
          //   setQuicktaleDetails({
          //     ...quicktaleDetails,
          //     coordinates: docData.coordinates,
          //     location: docData.location,
          //     g: docData.g,
          //   });
          //   // setQuicktaleDetails({ ...quicktaleDetails, ...docData });
          // }}
        />

        {/*Geo Hash section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Geohash"}
          value={quicktaleDetails?.g?.geohash}
          disabled={true}
        />
        {/*Lat/long section*/}
        {/* <QTDetailsLatLongSection
          label={"Lat/Long"}
          quicktaleDetails={quicktaleDetails}
          // latValue={quicktaleDetails?.coordinates?._lat}
          // longValue={quicktaleDetails?.coordinates?._long}
          onUpdate={(data) => {
            setQuicktaleDetails({
              ...quicktaleDetails,
              coordinates: data.coordinates,
              location: data.location,
              g: data.g,
            });
          }}
          disabled={true}
          editEnabled={editEnabled}
        /> */}

        <QTDetailsLatLongSection
          label={"Lat/Long"}
          // quicktaleDetails={quicktaleDetails}
          value={
            quicktaleDetails?.coordinates?._lat +
            "," +
            quicktaleDetails?.coordinates?._long
          }
          latValue={quicktaleDetails?.coordinates?._lat}
          longValue={quicktaleDetails?.coordinates?._long}
          onChange={(data) => {
            setQuicktaleDetails({
              ...quicktaleDetails,
              coordinates: data.coordinates,
              location: data.location,
              locationDisplay: data.locationDisplay,
              locationCountry: data.locationCountry,
              g: data.g,
            });
          }}
          disabled={true}
          editEnabled={editEnabled}
        />
      </Grid>
    </Grid>
  );
};

export default DetailsPageBottomCardSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginTop: 30,
};
